import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
const Footer = ({ theme, toggleTheme }) => {
  return (
    <React.Fragment>
      <footer className="footer bg-light pb-3 mt-auto">
        <Container>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © danubehome.com.</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Design & Develop by DH Tech Team
              </div>
            </Col>
          </Row>
        </Container>
        {/* Theme Toggle Button */}
        <Button
          onClick={toggleTheme}
          className={`position-fixed px-2 rounded-pill ${
            theme === "dark" ? "bg-white text-dark" : "bg-dark text-white"
          }`}
          style={{
            bottom: 80,
            right: 30,
            lineHeight: 0,
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          }}
        >
          {theme === "dark" ? (
            <i className="bx bx-sun fs-28"></i>
          ) : (
            <i className="bx bx-moon fs-28"></i>
          )}
        </Button>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
